var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("el-dialog", {
    attrs: {
      title: "",
      visible: _vm.isShowDialog,
      "show-close": true,
      modal: "",
      "close-on-click-modal": false,
      "modal-append-to-body": false,
      width: "440px"
    },
    on: {
      close: _vm.cancel
    }
  }, [_c("div", [_c("img", {
    attrs: {
      src: require("../../assets//img/serviceQRcode.png"),
      alt: ""
    }
  })])]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };